module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_4_preview.2fc00406.jpg";